import { getRegionConfig, isPremium } from '@/helpers/helpers';
import { UserData } from '@/types';
import { useMemo } from 'react';

interface UseRealmLimitPopupProps {
  userData: UserData | null | undefined;
}

/**
 * Custom hook to determine if the realm limit exceeded popup should be shown
 * Returns true if user has > 25 EU selling realms and is not premium
 */
export const useRealmLimitPopup = ({ userData }: UseRealmLimitPopupProps) => {
  const shouldShowPopup = useMemo(() => {
    if (!userData || isPremium(userData.accessType) === true) {
      return false
    }

    const config = getRegionConfig(userData)
    const realms = config.sellingRealms.map(r => r.realmId)

    return (realms?.length ?? 0) > userData.dataConfiguration.sellingRealms
  }, [userData])

  return shouldShowPopup
}